export const CUSTOMER_STATUS = {
  ACTIVE: "ACTIVE",
  POTENTIAL: "POTENTIAL",
} as const;

export const CUSTOMER_STATUS_TO_TYPE_LABEL = {
  [CUSTOMER_STATUS.ACTIVE]: "Advocate",
  [CUSTOMER_STATUS.POTENTIAL]: "Potential customer",
} as const;

export const CUSTOMER_STATE = {
  unknown: "unknown",
  onboarded: "onboarded",
  opted_in: "opted_in",
  opted_out: "opted_out",
} as const;
